/**
 * StudioIntro.jsx — Dallas Pottery Workshops intro strip
 *
 * A compact tile between the Hero and The Sessions carousel that
 * establishes the studio's offer in plain language. Consists of:
 *   - A short descriptive paragraph (centred)
 *   - A hairline-divided 3-column pillar row with quick-scan highlights
 *
 * Content is Firestore-backed via useHomepageContent (siteContent/homepage).
 */
import { useHomepageContent } from '../services/firestore';

export default function StudioIntro() {
  const { content } = useHomepageContent();

  const pillars = [
    { label: content.pillar1Label, note: content.pillar1Note },
    { label: content.pillar2Label, note: content.pillar2Note },
    { label: content.pillar3Label, note: content.pillar3Note },
  ];

  return (
    <div className="section-pad">
      <div
        style={{
          background: '#F9F2E9',
          borderRadius: 16,
          overflow: 'hidden',
          position: 'relative',
          zIndex: 51,
        }}
      >
        {/* ── Intro paragraph ───────────────────────────────────────────── */}
        <div
          style={{
            padding: '40px 60px 32px',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              fontFamily: "'Titan One', sans-serif",
              fontWeight: 400,
              fontSize: 'clamp(1.4rem, 2.5vw, 2rem)',
              color: '#1a1208',
              letterSpacing: '-0.02em',
              textTransform: 'uppercase',
              marginBottom: 16,
            }}
          >
            {content.introTitle}
          </div>
          <div
            style={{
              fontFamily: "'Raleway', sans-serif",
              fontWeight: 600,
              fontSize: 'clamp(0.9rem, 1.4vw, 1rem)',
              color: '#9C7A3C',
              lineHeight: 1.85,
              maxWidth: 560,
              margin: '0 auto',
            }}
          >
            {content.introDescription
              .split('\n')
              .filter((p) => p.trim())
              .map((paragraph, i) => (
                <p key={i} style={{ margin: i === 0 ? 0 : '1em 0 0' }}>
                  {paragraph}
                </p>
              ))}
          </div>
        </div>

        {/* ── Inset horizontal divider ──────────────────────────────────── */}
        <div style={{ height: 1, background: '#EAE4DC', margin: '0 40px' }} />

        {/* ── 3-pillar strip ────────────────────────────────────────────── */}
        <div className="three-pillar">
          {pillars.map(({ label, note }, _i) => (
            <div key={label} className="pillar-item">
              <div
                style={{
                  fontFamily: "'Raleway', sans-serif",
                  fontWeight: 700,
                  fontSize: 'clamp(1.05rem, 1.8vw, 1.25rem)',
                  color: '#1a1208',
                  lineHeight: 1.5,
                  marginBottom: 4,
                }}
              >
                {label}
              </div>
              <div
                style={{
                  fontFamily: "'Raleway', sans-serif",
                  fontWeight: 600,
                  fontSize: 'clamp(0.9rem, 1.4vw, 1rem)',
                  color: '#9C7A3C',
                  letterSpacing: '0.01em',
                  whiteSpace: 'pre-line',
                }}
              >
                {note}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
